module.exports = "/images/qa.svg?49a46d774a4682d89ff0b1b9ba54c1a5";